import { Zap, Twitter, Github, Send } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-24 relative z-10">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-8 h-8 rounded-md bg-[#00F0FF] flex items-center justify-center">
              <Zap className="w-5 h-5 text-black" strokeWidth={3} />
            </span>
            <span className="font-heading font-black text-xl uppercase">Jixxeo<span className="text-[#00F0FF]">.</span>Apps</span>
          </div>
          <p className="text-white/50 text-sm max-w-sm">
            Discover. Publish. Launch. Without Limits. Independent app marketplace built for creators and pioneers.
          </p>
          <div className="flex gap-3 mt-6">
            {[Twitter, Github, Send].map((I, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-lg border border-white/10 flex items-center justify-center text-white/60 hover:text-[#00F0FF] hover:border-[#00F0FF]/40 transition-colors">
                <I className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="mono text-[10px] uppercase tracking-widest text-white/40 mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/browse" className="hover:text-[#00F0FF]">Browse Apps</Link></li>
            <li><Link to="/categories" className="hover:text-[#00F0FF]">Categories</Link></li>
            <li><Link to="/developers" className="hover:text-[#00F0FF]">Developers</Link></li>
          </ul>
        </div>
        <div>
          <div className="mono text-[10px] uppercase tracking-widest text-white/40 mb-4">Company</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/contact" className="hover:text-[#00F0FF]" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/privacy" className="hover:text-[#00F0FF]" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#00F0FF]" data-testid="footer-terms">Terms of Service</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 mono text-xs text-white/40 text-center">
        © 2026 Jixxeo Systems · Built independent, shipped fearless.
      </div>
    </footer>
  );
}
